import { render, staticRenderFns } from "./collaborators-select-loader.vue?vue&type=template&id=5c683bb8"
import script from "./collaborators-select-loader.vue?vue&type=script&lang=js"
export * from "./collaborators-select-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports